module.exports = __webpack_public_path__ + "img/LFB_menu_logo.58e65ea8.svg";